"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfig = exports.getNodeFromMeta = exports.getFieldFromMeta = exports.getConfigFromMeta = void 0;
var _react = require("react");
var _Context = require("../components/Context");
const useConfig = () => (0, _react.useContext)(_Context.ConfigContext);
exports.useConfig = useConfig;
const getFieldFromMeta = name => {
  const field = window.document.head.querySelector(`[name="${name}"]`);
  return field ? field.content : null;
};
exports.getFieldFromMeta = getFieldFromMeta;
const getNodeFromMeta = name => {
  const nodes = window.document.head.querySelectorAll(`[name^="${name}"]`);
  return Array.from(nodes).reduce((sum, element) => ({
    ...sum,
    [element.name.split('.')[1]]: element.content
  }), {});
};
exports.getNodeFromMeta = getNodeFromMeta;
const ignoredFields = ['robots', 'viewport', 'version', 'hash'];
const getConfigFromMeta = () => {
  const nodes = window.document.head.querySelectorAll('meta[name]');
  return Array.from(nodes).filter(node => node.name && !ignoredFields.includes(node.name)).reduce((acc, node) => {
    const {
      name,
      content
    } = node;
    if (name.includes('.')) {
      const [nodeSlice, field] = name.split('.');
      return {
        ...acc,
        [nodeSlice]: {
          ...acc[nodeSlice],
          [field]: content
        }
      };
    }
    return {
      ...acc,
      [name]: content
    };
  }, {});
};
exports.getConfigFromMeta = getConfigFromMeta;